import { PrinterType } from '@core/services/system/receipt-printers/enum/printer-type.enum';

/**
 * The printer itself confirmed before printing that it cannot print (no paper, cover open).
 * Nothing was sent to the printer, and the print queue fails the item immediately without any
 * automatic retry; the operator fixes the printer and uses Repeat.
 */
export class PrinterNotReadyError extends Error {
  constructor(
    public readonly printerType: PrinterType,
    public readonly reason: string,
    public readonly originalMessage: string,
    public readonly originalError?: unknown,
    /** True when the Star plugin before 7.3.2 reported this failure as a successful print (iOS). */
    public readonly legacyIosSuccess: boolean = false
  ) {
    super(`[${printerType}] Printer not ready (${reason}): ${originalMessage}`);
    this.name = 'PrinterNotReadyError';

    // Preserve prototype chain across the TS down-level emit so that
    // `error instanceof PrinterNotReadyError` works reliably at consumer sites.
    Object.setPrototypeOf(this, PrinterNotReadyError.prototype);
  }
}
